var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sku-bulk-upload-container" }, [
    _c(
      "div",
      { staticClass: "sku-bulk-upload-drop-zone" },
      [
        _c(
          "vue-dropzone",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.processing.visible,
                expression: "!processing.visible"
              }
            ],
            ref: "dropzone-" + _vm.parentId,
            staticClass: "vue-dropzone",
            attrs: {
              id: "vue-dropzone-" + _vm.parentId,
              options: _vm.dropzoneOptions,
              "use-custom-slot": true,
              "include-styling": false
            },
            on: {
              "vdropzone-file-added": function($event) {
                return _vm.fileUploadAdded()
              },
              "vdropzone-sending": function(file, xhr) {
                return _vm.fileUploadSending(file, xhr)
              },
              "vdropzone-upload-progress": function(file, progress) {
                return _vm.fileUploadProgress(file, progress)
              },
              "vdropzone-success": function(file, items) {
                return _vm.fileUploaded(file, items)
              },
              "vdropzone-complete": function($event) {
                return _vm.fileUploadComplete()
              },
              "vdropzone-max-files-exceeded": function() {
                return _vm.fileUploadError(
                  _vm.$t("items.bulk.error.multipleFiles")
                )
              },
              "vdropzone-error": function(file, message) {
                return _vm.fileUploadError(
                  message ||
                    _vm.$t("items.bulk.error.serverError", { file: file.name })
                )
              }
            }
          },
          [
            _c(
              "button",
              { staticClass: "drop-zone", attrs: { type: "button" } },
              [
                _c(
                  "svg",
                  {
                    staticClass: "drop-zone__icon",
                    attrs: { width: "90", height: "90" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#file-upload" } })]
                ),
                _c("p", { staticClass: "drop-zone__title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("items.bulk.dropSkuTemplate")) +
                      "\n                "
                  )
                ]),
                _c("div", { staticClass: "drop-zone__text" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("general.or")) +
                      "\n                    "
                  ),
                  _c("span", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "general.files.selectFile",
                        expression: "'general.files.selectFile'"
                      }
                    ],
                    staticClass: "drop-zone__link"
                  })
                ])
              ]
            )
          ]
        ),
        _vm.processing.visible
          ? _c("progress-bar", {
              attrs: {
                slot: "overlay",
                "allow-cancel": _vm.stage !== "cancelled",
                "cancel-text": _vm.$t("general.cancel"),
                value: _vm.processing.value,
                message: _vm.processing.message
              },
              on: { cancel: _vm.onCancelAction },
              slot: "overlay"
            })
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "need-template" },
      [
        _c("label", { staticClass: "need-template-label" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("items.bulk.needSkuTemplate")) +
              "\n        "
          )
        ]),
        _c(
          "base-button",
          {
            attrs: {
              tag: "a",
              href: _vm.downloadTemplateUrl,
              target: "_blank",
              primary: "",
              size: "sm"
            }
          },
          [
            _c(
              "svg",
              {
                attrs: { slot: "iconLeft", width: "16", height: "16" },
                slot: "iconLeft"
              },
              [_c("use", { attrs: { "xlink:href": "#download" } })]
            ),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("general.files.download")) +
                "\n        "
            )
          ]
        ),
        _c("div", { staticClass: "sku-limit-info" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.parentComponent == "asn"
                  ? _vm.$t("items.bulk.skuLimitInfoAsn", {
                      skuLimit: _vm.maxSkuInFile
                    })
                  : _vm.$t("items.bulk.skuLimitInfo", {
                      skuLimit: _vm.maxSkuInFile
                    })
              ) +
              "\n        "
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }